import {useState, useEffect} from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { useRouteSettings, useRouteSettingsActions } from '../../stores/RouteSettingsStore';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  disablePortal: true
};

const roadFeatureTypes = [
    'Bomstasjon',
    'Rasteplass',
    'Vegkamera',
    'Height',
    'Dognhvileplass',
    'Ladestasjon',
    'Turistveg',
    'Ferge',
    'TrafficMessage',
    'SwedishTrafficMessage',
    'FinnishTrafficMessage',
    'Vegsperring',
    'VarutsattVeg',
    'MeasurementSite',
    'JernbanekryssingMedSaerskiltFare',
    'Tunnel',
    'Bru',
    'Trafikkregulering'
];

export default function DropdownInput() {
    const routeSettings = useRouteSettings();
    const { setRouteSettings } = useRouteSettingsActions();

    const [avoidRoadFeatureTypes, setAvoidRoadFeatureTypes] = useState<string[]>(routeSettings.avoidRoadFeatureTypes ?? []);

  useEffect(() => {
    setRouteSettings({
        ...routeSettings,
        avoidRoadFeatureTypes: avoidRoadFeatureTypes
        }
    );
  }, [avoidRoadFeatureTypes]);

  const handleChange = (event: SelectChangeEvent<typeof roadFeatureTypes>) => {
    const { target: { value }, } = event;
    const roadFeatureTypes = typeof value === 'string' ? value.split(',') : value;
    
    setAvoidRoadFeatureTypes(roadFeatureTypes); 
  };

  return (
    <div>
      <FormControl sx={{ m: 0, width: 289 }}>
        <InputLabel>AvoidRoadFeatureTypes</InputLabel>
        <Select
          multiple
          value={avoidRoadFeatureTypes}
          onChange={handleChange}
          input={<OutlinedInput label="AvoidRoadFeatureTypes" />}
          renderValue={(selected) => selected.join(',')}
          MenuProps={MenuProps}
        >
          {roadFeatureTypes.map((roadFeatureType) => (
            <MenuItem key={roadFeatureType} value={roadFeatureType}>
              <Checkbox checked={avoidRoadFeatureTypes.includes(roadFeatureType)} />
              <ListItemText primary={roadFeatureType} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}